import { Button, Row, Space, Table, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { dmLoaiDVKTColumns, dmNhomDVKTColumns, dmTrangThaiDVKTColumns } from './config';
import './Catalog.scss';
import {technicalService} from 'api';
import { ListActionButton, Notification } from 'components/common';
import GroupVTYTModal from './GroupVTYTModal/GroupVTYTModal';

const Catalog = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [dmTrangThai, setDmTrangThai] = useState<any>([]);
  const gVRef = useRef<any>();

  const fetchDanhMucTrangThai = async () => {
    try {
      setLoading(true)
      let response = await technicalService.getDanhMucTrangThai();
      setDmTrangThai(response)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }
  const [nhomDvkt, setNhomDvkt] = useState<any>([])
  const fetchDanhMucNhomDVKT = async () => {
    try {
      setLoading(true)
      let response = await technicalService.getDanhMucNhomDVKT();
      setNhomDvkt(response)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }
  const [loaiDvkt, setLoaiDvkt] = useState<any>([])
  const fetchDanhMucLoaiDVKT = async () => {
    try {
      setLoading(true)
      let response = await technicalService.getDanhMucLoaiDVKT();
      setLoaiDvkt(response)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }
  const onAddGroupVTYT = async () => {
    gVRef.current?.setData(null)
    gVRef.current?.openModal();
  }
  const onEditNhomDVKTFunc = async (record) => {
    gVRef.current?.setData({...record})
    gVRef.current?.openModal();
  }

  const onSaveGroupVTYT = async (values, type) => {
    try {
      if(type === 0) {
        let response = await technicalService.postDanhMucNhomDVKT({
          ...values
        })
      } else if( type === 1) {
        let response = await technicalService.putDanhMucNhomDVKT({
          ...values
        })
      }
      Notification("success", type === 0 ? "Thêm thành công!": "Sửa thành công!")
      fetchDanhMucNhomDVKT()
    } catch (err) {
      
    }
  }

  useEffect(() => {
    fetchDanhMucTrangThai()
    fetchDanhMucLoaiDVKT()
    fetchDanhMucNhomDVKT()
  }, [])
  useEffect(() => {

  }, [dmTrangThai, nhomDvkt, loaiDvkt])
  dmNhomDVKTColumns.map(it => {
    if(it.dataIndex === "action") {
      it.render = (v, r, i) => {
        return <ListActionButton editFunction={() => onEditNhomDVKTFunc(r)}/>
      }
    }
  })
  return (
    <div className='catalog'>
      <div className='container'>
        <Row>
          <Space direction='vertical'>
            <Row justify={'space-between'}>
              <Typography.Text strong>Danh mục nhóm dịch vụ kỹ thuật</Typography.Text>
              <GroupVTYTModal ref={gVRef} onSave={onSaveGroupVTYT}/>
              <Button type="primary" onClick={onAddGroupVTYT}>Thêm mới</Button>
            </Row>
            <Row>
              <Table
                columns={dmNhomDVKTColumns}
                dataSource={nhomDvkt}
                bordered
              />
            </Row>
          </Space>
        </Row>
      </div>

      <div className='container'>
        <Row>
          <Space direction='vertical'>
            <Row>
              <Typography.Text strong>Danh mục trạng thái dịch vụ kỹ thuật</Typography.Text>
            </Row>
            <Row>
              <Table
                columns={dmTrangThaiDVKTColumns}
                dataSource={dmTrangThai}
                bordered
              />
            </Row>
          </Space>
        </Row>
      </div>
      <div className='container'>
        <Row>
          <Space direction='vertical'>
            <Row>
              <Typography.Text strong>Danh mục phân loại dịch vụ kỹ thuật</Typography.Text>
            </Row>
            <Row>
              <Table
                columns={dmLoaiDVKTColumns}
                dataSource={loaiDvkt}
                bordered
              />
            </Row>
          </Space>
        </Row>
      </div>
    </div>
  );
};

export default Catalog;